import { useEffect, useState } from "react";

/**
 * Cycles through an array of image URLs and returns the currently-active index.
 * Renders a stack of <img>s with CSS crossfade in the parent component.
 */
export const useRotatingIndex = (count, intervalMs = 8000) => {
    const [idx, setIdx] = useState(0);
    useEffect(() => {
        if (!count || count < 2) return undefined;
        const t = setInterval(() => setIdx((i) => (i + 1) % count), intervalMs);
        return () => clearInterval(t);
    }, [count, intervalMs]);
    return idx;
};

export const RotatingHero = ({ images = [], fallback, className = "", intervalMs = 8000 }) => {
    const srcs = images && images.length > 0 ? images : fallback ? [fallback] : [];
    const idx = useRotatingIndex(srcs.length, intervalMs);
    return (
        <div className={className}>
            {srcs.map((url, i) => (
                <img
                    key={`${url}-${i}`}
                    src={url}
                    alt=""
                    className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1800ms] ease-out ${
                        i === idx ? "opacity-100" : "opacity-0"
                    }`}
                />
            ))}
        </div>
    );
};
